<div class="accommodation-options__shared-room">
  <ng-container *ngFor="let roomTypeLabel of roomTypeLabels; let isLast = last"> {{ roomTypeLabel }}{{ isLast ? '' : ', ' }} </ng-container>
</div>
<div class="accommodation-options__shared-bathroom">
  <ng-container *ngFor="let bathroomTypeLabel of bathRoomTypeLabels; let isLast = last"> {{ bathroomTypeLabel }}{{ isLast ? '' : ', ' }} </ng-container>
</div>
<div class="accommodation-options__meals">
  <ng-container *ngFor="let mealOptionLabel of mealOptionLabels; let isLast = last"> {{ mealOptionLabel }}{{ isLast ? '' : ', ' }} </ng-container>
</div>
